<template>
    <select2 v-model="unitId" :options="topLevelUnits"
             :allowClear="allowClear"
             style="width:100%"
             :multiple="multiple"
             :placeholder="placeholder"></select2>
</template>
<script>

    export default {
        name: 'TopLevelUnit',
        props: {
            value: {
                type: [String, Number, Array]
            },
            placeholder: {
                type: String,
                default: '--- Tất cả ---'
            },
            options: {
                type: Array,
                default: null
            },
            allowClear: {
                type: [String, Boolean],
                default: false
            },
            cached: {
                type: [String, Boolean],
                default: false
            },
            multiple: {
                type: [String, Boolean],
                default: false
            }
        },
        data() {
            return {
                unitId: null,
                topLevelUnits: []
            };
        },
        created: function () {
            if (this.options == null) {
                this.topLevelUnits = this.$store.state.common.topLevelUnits;
            } else {
                this.topLevelUnits = this.options;
            }

            if (this.value) {
                this.unitId = this.value;
            } else if (this.topLevelUnits.length == 1) {
                this.unitId = this.topLevelUnits[0].id;
            }

            //if (this.cached) {
            //    var vm = this;
            //    this.$nextTick(() => {
            //        if (vm.value) {
            //            vm.unitId = vm.value;
            //        } else {
            //            vm.unitId = window.localStorage.getItem(`tsc:topLevelUnitId`);
            //        }
            //    })
            //}
        },
        methods: {

        },
        watch: {
            unitId() {
                this.$emit('input', this.unitId);

                if (this.cached) {
                    if (!this.unitId) {
                        window.localStorage.setItem(`tsc:topLevelUnitId`, '');
                        this.$store.commit("setCurrentUnit", '');
                    } else {
                        window.localStorage.setItem(`tsc:topLevelUnitId`, this.unitId);
                        var selected = this.topLevelUnits.find(x => x.id == this.unitId);
                        if (selected) {
                            this.$store.commit("setCurrentUnit", selected.text);
                        }
                    }
                }
            },
            value() {
                this.unitId = this.value;
            }
        }
    }
</script>
<style scoped>
</style>

